import React from 'react';
import { useTranslation } from 'react-i18next';
import TripletexIntegration from './TripletexIntegration.jsx';
import './Settings.css';

/**
 * Main Settings page component
 * Contains all integration and configuration settings
 * @returns {JSX.Element} Settings component
 */
const Settings = () => {
  const { t } = useTranslation();
  
  return (
    <div className="settings">
      <div className="settings-header">
        <h1>{t('settings.title')}</h1>
        <p className="settings-description">
          {t('settings.description')}
        </p>
      </div>

      <div className="settings-content">
        <div className="settings-section">
          <TripletexIntegration />
        </div>

        {/* Future settings sections can be added here */}
        {/* 
        <div className="settings-section">
          <OtherIntegration />
        </div>
        */}
      </div>
    </div>
  );
};

export default Settings;
